(ns superadmin.malware-scans.queries
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn malware-scans-all
  []
  #js {:queryKey #js ["malware-scans-all"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :superadmin-api/malware-scans-all {})))})

(defn block-adset-mutation
  []
  #js {:mutationKey #js ["block-adset-mutation"]
       :mutationFn (fn [[adset-id block?]]
                     (qhttp/post (qhttp/render
                                  :superadmin-api/malware-block-adset {:adset-id adset-id})
                                 {:body {:blocked block?}}))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["malware-scans-all"]}))})

(defn activate-mailware-job-mutation
  []
  #js {:mutationKey #js ["activate-mailware-job-mutation"]
       :mutationFn (fn [job-id]
                     (qhttp/post (qhttp/render
                                  :superadmin-api/malware-scan-job-initialize {:job-id job-id})
                                 {:body {:initialize true}}))
       :onSuccess (fn []
                    (rf/dispatch [:toaster-bus/add {:type :success
                                                    :message "Malware scan job was initialized successfully."}])
                    (invalidate-queries {:queryKey ["malware-scans-all"]}))
       :onError (fn [data]
                  (let [error-message (-> data ->clj :data ->clj :data :initialization-response str)]
                    (rf/dispatch [:toaster-bus/add {:type :error
                                                    :message "Malware scan job initialization failed."
                                                    :full-message error-message}])
                    (invalidate-queries {:queryKey ["malware-scans-all"]})))})
